export * from './components/FunnelChart/index';
